const vueHomePageBlogPosts = new Vue({
    name: "vueHomePageBlogPosts",
    el: "#vueHomePageBlogPosts",
    data: { 
        blogPosts: []
    },
    mixins: [
        requestServiceMixin,
        blogServiceMixin
    ],
    mounted: function () {
        const vm = this;
        vm.getPosts();
    },
    methods: {
        getPosts: function () {
            const vm = this;

            const data = {
                category: vm.category,
                page: vm.page
            }

            vm.getHomePageBlogPosts(data)
                .then(function (response) {
                    if (!response) 
                        return;

                    const content = response.data.content;

                    vm.blogPosts = content.blogs;
                });
        }
    }
});